import { routes } from '@/shared/routes';
import { AmlContextResponse } from '@/shared/types/aml';

import { checkAmlIntercept } from '@/front/actions/xama';
import { GET } from '@/front/fetch';
import { registerGridButtonInterceptor } from '@/front/grid';
import { alertModal } from '@/front/modal';

registerGridButtonInterceptor('setDateToToday', async (context) => {
  const { modelName, field, toggled, id, button, refreshRow } = context;

  if (field !== 'completedDate' || modelName !== 'TaskView') {
    return false;
  }

  if (button.disabled || button.dataset.disabled === 'true') {
    return true;
  }

  if (toggled === 'true') {
    try {
      const res = await GET(routes.tasks.amlContext({ id }));
      const amlContext: AmlContextResponse = await res.json();
      if (amlContext.requiresAml && amlContext.xamaLinked) {
        alertModal('AML Risk Assessment is managed by the external AML provider');
        return true;
      }
    } catch (error) {
      console.error('Failed to check AML context', error);
    }
    return false;
  }

  return checkAmlIntercept(id, {
    onComplete: () => refreshRow(),
    skipRedirect: true,
  });
});
